export { default as handleClickIntent } from "./handleClickIntent";
export { default as handleClickSolution } from "./handleClickSolution";
